module.exports = __webpack_public_path__ + "static/img/driblab_normal_white.3fe34a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_normal_white.png
// module id = ZwhF
// module chunks = 79